<svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="33" cy="33" r="27" fill="#B61D22"/>
<circle cx="33" cy="33" r="32" stroke="#D9D9D9" stroke-width="2"/>
</svg>
